/**
 * Display-time cleaning of a stored generation failure message.
 *
 * Failures stored before 2026-10-12 can name the text-generation provider
 * (e.g. "Gemini returned empty text"). Users must not read that, and stored
 * data is not rewritten, so every "Previous generation failed" banner shows
 * its text through this function. Mirrors functions/src/utils/userFacingMessage.ts
 * (keep the pattern and the plain message identical).
 */
export const PLAIN_GENERATION_FAILURE = 'The document could not be generated this time. Try again.';

const PROVIDER_NAMED = /gemini|generative\s*ai|googlegenerativeai|generativelanguage|vertex\s*ai|\bllms?\b/i;

export function displayGenerationError(raw: unknown): string {
  const s = typeof raw === 'string' ? raw.trim() : '';
  if (!s || PROVIDER_NAMED.test(s)) return PLAIN_GENERATION_FAILURE;
  return s;
}
